module.exports = __webpack_public_path__ + "img/no_info.3ded1d8e.png";